<template>
  <div>
    <v-form ref="updateCompany">
      <v-container style="padding: 1% 3%;">
        <v-row>
          <v-col cols="3">
            <v-text-field
              v-model="updatedCompany.name"
              label="Ad-Soyad / Ünvan"
              :rules="[rules.required]"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="updatedCompany.info.taxOffice"
              label="Vergi Dairesi"
              :rules="[rules.required]"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="updatedCompany.tinNumber"
              label="Vergi Kimlik Numarası"
              :rules="[rules.required]"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="updatedCompany.info.city"
              label="Şehir"
              :rules="[rules.required]"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="updatedCompany.info.address"
              label="Adres"
              :rules="[rules.required]"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="updatedCompany.info.sector"
              label="Sektör"
              :rules="[rules.required]"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="updatedCompany.info.fax"
              label="Fax"
              :rules="[rules.required]"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="updatedCompany.info.telephone"
              label="Telefon"
              :rules="[rules.required]"
            ></v-text-field>
          </v-col>
        </v-row>
        <hr />
        <v-btn color="blue darken-1" style="float: right;" text @click="save()">
          değişiklikleri kaydet
        </v-btn>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import * as userReq from "../../request/user.js";
export default {
  name: "CompanyDetailsUpdate",
  props: ["company", "popUpStatus"],
  data() {
    return {
      updatedCompany: JSON.parse(JSON.stringify(this.company)),
      rules: {
        required: (value) => !!value || "Gerekli.",
        counter: (value) =>
          value.toString().length == 11 || "Vergi No 11 rakam olmalı",
        isNumber: (val) => Number.isInteger(val) || "Vergi No rakam olmalı",
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Geçersiz Email";
        },
      },
    };
  },
  watch: {
    popUpStatus() {
      this.updatedCompany = JSON.parse(JSON.stringify(this.company));
    },
  },
  methods: {
    save() {
      if (this.$refs.updateCompany.validate()) {
        userReq
          .updateCompanyInfo(this.updatedCompany)
          .then((res) => {
            if (res.data.data.value == 1) {
              this.$emit("refresh");
              this.$store.state.snackbarErrorObj = {
                snackbar: true,
                color: "success",
                text: "Kaydedildi",
                timeout: 1500,
              };
            }
          })
          .catch((err) => console.log(err));
      }
    },
  },
};
</script>

<style></style>
